import { render, staticRenderFns } from "./Deals.vue?vue&type=template&id=50a95fd2&scoped=true&"
import script from "./Deals.vue?vue&type=script&lang=js&"
export * from "./Deals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a95fd2",
  null
  
)

export default component.exports